// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wu_a big_b","TwoDimsListFeature__item":"wu_b big_we","TwoDimsListFeature__item__text":"wu_c big_vt"};